import { Link } from "@tanstack/react-router";

import { CitiesIcon } from "./icons";

export default function AllCitiesCard() {
  return (
    <div className="relative flex w-7/10 shrink-0 flex-col items-center justify-center overflow-hidden rounded-[30px] bg-linear-0 bg-white from-berry/10 to-berry/10 md:w-[261px]">
      <CitiesIcon />
      <h6 className="mt-[9px] font-semibold text-22/[1.5em]">
        <Link
          className="link-overlay bg-linear-290 from-cerise to-amaranth bg-clip-text text-transparent"
          to="/cities"
        >
          View all cities
        </Link>
      </h6>
    </div>
  );
}
